module.exports = __webpack_public_path__ + "static/media/is-bankasi.68513e28.svg";